<template>
  <v-row justify="center" class="my-0 py-4">
    <Chat></Chat>

    <v-col cols="11" class="white rounded-xl">
      <v-row class="ma-1">
        <v-row class="ma-0 d-flex mx-auto">
          <v-col :cols="$vuetify.breakpoint.mdAndUp ? 8 : 12">
            <span class="wc-h6 text-primary-variant"
              >Crea publicaciones para tu audiencia activa</span
            >
          </v-col>
          <!--<v-col cols="1">
            <v-btn icon>
              <v-icon>mdi-chart-timeline-variant-shimmer</v-icon>
            </v-btn>-->

          <!-- <v-btn icon>
              <v-icon>mdi-tune</v-icon>
            </v-btn>
          </v-col>-->
          <v-col cols="3" class="d-flex justify-center">
            <v-btn
              outlined
              color="primary"
              class="mr-2"
              @click="addSection"
              :rounded="$vuetify.breakpoint.mdAndUp"
              :fab="!$vuetify.breakpoint.mdAndUp"
              elevation="0"
            >
              <v-icon class="black--text">mdi-table-row-plus-after</v-icon>
              <span v-if="$vuetify.breakpoint.mdAndUp" class="font-weight-bold black--text">Agregar sección</span>
            </v-btn>
            <v-btn
              @click="createPost"
              color="accent"
              :absolute="!$vuetify.breakpoint.mdAndUp"
              bottom
              right
              :fixed="!$vuetify.breakpoint.mdAndUp"
              :style="$vuetify.breakpoint.mdAndUp || 'zIndex: 1; bottom: 20px;'"
              :rounded="$vuetify.breakpoint.mdAndUp"
              :fab="!$vuetify.breakpoint.mdAndUp"
              elevation="0"
            >
              <v-icon class="black--text">mdi-plus</v-icon>
              <span
                v-if="$vuetify.breakpoint.mdAndUp"
                class="font-weight-bold black--text"
                >Nueva Publicación</span
              >
              <v-icon v-else size="30">mdi-plus</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-row>
      <div class="modal" transition="modal-slide-right">
        <!-- Modal content goes here -->
      </div>
      <v-divider></v-divider>
      <v-row>
        <v-col class="pa-0">
          <v-tabs :color="color.primaryVariant" v-model="sectionTab" show-arrows>
            <v-tab v-for="section in sectionTabs" :key="section._id || 'unsectioned'">
              <span class="wc-caption-1">{{ section.name }}</span>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="sectionTab">
            <v-tab-item v-for="section in sectionTabs" :key="section._id || 'unsectioned'">
              <v-row v-if="section._id" align="center" class="mt-3 mb-1 px-4" no-gutters>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                    v-model="section.name"
                    label="Nombre de la sección"
                    dense
                    filled
                    rounded
                    hide-details
                    @focus="section._editing = true"
                  />
                </v-col>
                <v-col cols="auto" class="ml-2">
                  <v-btn
                    v-if="section._editing"
                    icon
                    small
                    color="green"
                    :loading="savingSectionId === section._id"
                    @click="saveSectionName(section)"
                  >
                    <v-icon small>mdi-content-save-outline</v-icon>
                  </v-btn>
                  <v-btn icon small color="red" @click="requestRemoveSection(section)">
                    <v-icon small>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </v-col>
              </v-row>

              <v-tabs :color="color.primaryVariant" v-model="tab">
                <v-tab><span class="wc-caption-1">Activas</span></v-tab>
                <v-tab><span class="wc-caption-1">Inactivas</span></v-tab>
              </v-tabs>
              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <post
                    :status="'PUBLISHED'"
                    :section-id="section._id"
                    :publications="fetchAllPublications"
                    @refresh="getPublications"
                  />
                </v-tab-item>
                <v-tab-item>
                  <post
                    :status="'DRAFT'"
                    :section-id="section._id"
                    :publications="fetchAllPublications"
                    @refresh="getPublications"
                  />
                </v-tab-item>
              </v-tabs-items>
            </v-tab-item>
          </v-tabs-items>

          <v-dialog v-model="sectionDeleteDialog" max-width="430">
            <v-card>
              <v-card-title>Eliminar sección</v-card-title>
              <v-card-text>
                Las publicaciones de esta sección pasarán a “Sin sección”. ¿Deseas continuar?
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn text @click="sectionDeleteDialog = false">Cancelar</v-btn>
                <v-btn color="red" text :loading="deletingSection" @click="removeSection">Eliminar</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Chat from "@/components/shared/Chat.vue";

import { colors } from "@/constants/colors";
import Post from "../../components/dashboard/myCommunity/Posts.vue";
import { mapActions, mapMutations } from "vuex";
import { fetchPublications } from "../../store/publications/actions";

export default {
  components: {
    Post,
    Chat,
  },
  data() {
    return {
      color: colors,
      tab: 0,
      sectionTab: 0,
      publications: [],
      sections: [],
      savingSectionId: null,
      deletingSection: false,
      sectionDeleteDialog: false,
      sectionToDelete: null,
      publication: {
        name: "",
        description: "",
        type: "BLOG",
        labels: [],
        images: [],
        status: "",
        value: "",
        section: null,
        status: "DRAFT",
      },
    };
  },
  computed: {
    tabContent() {
      if (this.selectedTab === "tab1") {
        // Logic for Tab 1 content
        return "Tab 1 Content";
      } else if (this.selectedTab === "tab2") {
        // Logic for Tab 2 content
        return "Tab 2 Content";
      }
    },

    fetchAllPublications() {
      return this.publications;
    },
    sectionTabs() {
      return [{ _id: null, name: "Sin sección" }, ...this.sections];
    },
  },
  methods: {
    ...mapActions("publications", ["fetchPublications", "createPublication"]),
    ...mapActions("publicationSections", [
      "getPublicationSectionsByOrg",
      "addPublicationSection",
      "updatePublicationSection",
      "deletePublicationSection",
    ]),
    ...mapMutations("loader", ["loading", "loaded"]),
    ...mapMutations("publications", ["setPublicationStatus"]),
    ...mapMutations("notification", ["show"]),

    async getPublications() {
      let publications = (await fetchPublications()).data;
      console.log(publications);
      const reformatPublications = publications.map((publication) => {
        return {
          ...publication,
          hover: true,
          deleteDialog: false,
          formatedDate: this.formatDate(publication.createdAt),
        };
      });
      this.publications = reformatPublications;
    },

    async createPost() {
      let response = await this.createPublication(this.publication);
      this.setPublicationStatus({
        mode: "CREATE",
        id: response.data.data.publication._id,
      });
      this.$router.push({
        name: "newPublish",
      });
    },

    async getSections() {
      const response = await this.getPublicationSectionsByOrg();
      this.sections = response.status ? (response.data.sections || []) : [];
    },

    async addSection() {
      const nextOrder = this.sections.reduce(
        (max, section) => Math.max(max, Number(section.order) || 0),
        0,
      ) + 1;
      const response = await this.addPublicationSection({
        name: "Nueva sección",
        order: nextOrder,
      });
      if (!response.status) {
        this.show({ color: "error", text: "No se pudo crear la sección" });
        return;
      }
      this.sections.push({ ...response.data.section, _editing: true });
      this.sectionTab = this.sections.length;
    },

    async saveSectionName(section) {
      this.savingSectionId = section._id;
      const response = await this.updatePublicationSection({
        id: section._id,
        payload: { name: section.name, order: section.order },
      });
      this.savingSectionId = null;
      if (response.status) {
        Object.assign(section, response.data.section, { _editing: false });
      } else {
        this.show({ color: "error", text: "No se pudo actualizar la sección" });
      }
    },

    requestRemoveSection(section) {
      this.sectionToDelete = section;
      this.sectionDeleteDialog = true;
    },

    async removeSection() {
      if (!this.sectionToDelete) return;
      this.deletingSection = true;
      const response = await this.deletePublicationSection(this.sectionToDelete._id);
      this.deletingSection = false;
      this.sectionDeleteDialog = false;
      if (!response.status) {
        this.show({ color: "error", text: "No se pudo eliminar la sección" });
        return;
      }
      this.sections = this.sections.filter((section) => section._id !== this.sectionToDelete._id);
      this.sectionToDelete = null;
      this.sectionTab = 0;
      await this.getPublications();
      this.show({ color: "primary", text: "Sección eliminada" });
    },

    formatDate(currentDate) {
      const date = new Date(currentDate);
      const dateOptions = { day: "numeric", month: "short", year: "numeric" };
      const timeOptions = { hour: "numeric", minute: "numeric" };
      let fullDate = date
        .toLocaleDateString("es-MX", dateOptions)
        .replaceAll(" ", "-")
        .toUpperCase();
      let fullTime = date
        .toLocaleTimeString("en-MX", timeOptions)
        .toUpperCase();
      return {
        date: fullDate,
        time: fullTime,
      };
    },
  },

  async created() {
    try {
      this.loading();
      await Promise.all([this.getPublications(), this.getSections()]);
    } catch (error) {
      console.log(error);
    } finally {
      this.loaded();
    }
  },
};
</script>

<!--Styles-->
<style>
.rounded-progress {
  border-radius: 20px;
}
.analytic-card {
  height: 90px;
}
</style>
